<template>
  <div class="my_collect">
    <loading v-if="isLoading"></loading>
    <div v-else>

      <div v-if="!isPageError">
        <div v-if="!isEmptyData">
          <div class="topic_box">
            <div class="topic_item" :class="{active:item.key == activeIndex}" v-for="(item,index) in topicList" :key="index" @click="topicClick(item.key)">{{item.name}}</div>
          </div>
          <!-- 活动赛事 -->
          <div class="activity_container" v-if="activeIndex == 'activity'">
            <!-- <div class="list_topInfo">
        <div class="topInfo_title">本月赏花</div>
        <div class="topInfo_right">
          <div class="topInfo_desc">栀子花 5.15-6.15</div>
          <div class="topInfo_middle">|</div>
          <div class="topInfo_time">30天</div>
        </div>
      </div> -->
            <div class="list">
              <div v-for="(item,index) in activityListData" :key="index" @click="toDetail(item)">
                <van-swipe-cell>
                  <left-img :imageWidth="75" :imageHeight="100" :src="item.imageUrl">
                    <template slot="right_container">
                      <div class="item_right_container">
                        <div class="item_left">
                          <div class="list_title">{{item.title}}</div>
                          <div class="list_timeLine">
                            <div class="timeLine_date">{{item.isResident == 1?'全年':changeTime(item.activityStartTime,item.activityEndTime)}}</div>
                            <div class="timeLine_middle" v-if="item.isResident != 1">|</div>
                            <div class="timeLine_day" v-if="item.isResident != 1">{{computedDays(item.activityStartTime,item.activityEndTime)}}天</div>
                          </div>
                          <div class="item_location" v-if="isShowDistance || item.scenicName">
                            <div class="location_name">{{item.scenicName}}</div>
                            <div class="timeLine_middle" v-if="isShowDistance">|</div>
                            <div class="location_distance" v-if="isShowDistance">{{calcDistance(item.latitude,item.longitude)}}km</div>
                          </div>
                          <div class="item_bottom">
                            <div class="item_fun">{{item.activityLikeCount?item.activityLikeCount:0}}人收藏</div>
                            <!-- <div class="item_charge">免费</div> -->
                          </div>
                        </div>
                      </div>
                      <div slot="item_right" class="item_right">
                        <!-- <div class="right_text">已结束</div> -->
                        <div class="right_text_before right_green" v-if="computeStatus(item,'活动') == '离开始状态'">
                          <div class="before_day">{{computedDays(new Date().getTime(),new Date(item.activityStartTime).getTime())}}<span>天</span></div>
                          <div class="before_desc">离开始还有</div>
                        </div>
                        <div class="right_text_before right_green" :style="{color:'#2eba73'}" v-if="computeStatus(item,'活动') == '离结束状态'">
                          <div class="before_day">{{computedDays(new Date().getTime(),new Date(item.activityEndTime).getTime())}}<span>天</span></div>
                          <div class="before_desc">离结束还有</div>
                        </div>
                        <div class="right_text_before" v-if="computeStatus(item,'活动') == '已结束'">
                          <div class="before_desc">已结束</div>
                        </div>
                        <div class="right_text_before right_green" :style="{color:'#2eba73'}" v-if="computeStatus(item,'活动') == '全年'">
                          <div class="before_desc">全年</div>
                        </div>
                      </div>
                    </template>
                  </left-img>
                  <template slot="right">
                    <div class="cell_right" @click="deleteItem(item)">
                      <div class="cell_right_content">
                        <div>取消</div>
                        <div>收藏</div>
                      </div>
                    </div>
                  </template>
                </van-swipe-cell>

              </div>

            </div>
          </div>
          <!-- 活动赛事 end-->

          <!-- 攻略 -->
          <div class="strategy_container" v-if="activeIndex == 'strategy'">
            <div class="item_container" v-for="(item,index) in strategyListData" :key="index" @click="toDetail(item)">
              <van-swipe-cell class="vanSwipeCell">
                <div class="item_container_strategy">
                  <van-image :width="75" :height="100" class="item_left_img" :src="item.imageUrl" lazy-load />
                  <slot name="right_container">
                    <div class="item_right">
                      <div class="right_title">{{item.title}}</div>
                      <div class="right_label">
                        <div class="label_item" v-for="(item,index) in item.labels" :key="index">{{item}}</div>
                        <!-- <div class="label_item" v-for="">亲子溜娃</div> -->
                      </div>
                      <div class="right_time">{{item.scenicName}}</div>
                      <div class="right_like">{{item.strategyLikeCount?item.strategyLikeCount:0}}人收藏<span v-if="item.strategyCommentCount">&nbsp;&nbsp;&nbsp;{{item.strategyCommentCount?item.strategyCommentCount:0}}条评论</span></div>
                    </div>
                  </slot>
                  <slot name="item_right"></slot>
                </div>
                <template slot="right">
                  <div class="cell_right" @click="deleteItem(item)">
                    <div class="cell_right_content">
                      <div>取消</div>
                      <div>收藏</div>
                    </div>
                  </div>
                </template>
              </van-swipe-cell>
            </div>
          </div>
          <!-- 攻略 end -->

          <!-- 游记 -->
          <!-- <div class="traveks_container" v-if="activeIndex == 2">
      <div class="travels_list">
        <van-swipe-cell>
          <div class="travels_item">
            <van-image :radius="3" class="left_img" :width="99" :height="66" src="https://dss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=1089874897,1268118658&fm=26&gp=0.jpg" lazy-load />
            <div class="right_container">
              <div class="travels_title">桂溪里的露天游乐场—父母轻松遛娃</div>
              <div class="travels_userInfo">
                <van-image round :width="18" :height="18" src="https://dss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=1089874897,1268118658&fm=26&gp=0.jpg" lazy-load />
                <div class="nickName">无助的猪蹄</div>
              </div>
              <div class="traveks_bottom">
                <span class="bottom_left">339人浏览</span>
                <span>389人收藏</span>
              </div>
            </div>
          </div>
          <template #right>
            <div class="travels_right" @click="cancelCollect">
              <div>取消</div>
              <div>收藏</div>
            </div>
          </template>
        </van-swipe-cell>

      </div>
    </div> -->
          <!-- 游记 end -->

          <!-- 绿道线路 -->
          <div class="line_container" v-if="activeIndex == 'green_route'">
            <div class="line_item" v-for="(item,index) in greenListData" :key="index" @click="toDetail(item)">
              <van-swipe-cell>
                <left-img :imageWidth="99" :imageHeight="66" :src="item.imageUrl" :item="item">
                  <div slot="right_like"></div>
                  <div slot="right_label">
                    <div class="right_label">
                      <div class="label_item" v-for="(item,index) in item.labels" :key="index">{{item}}</div>
                      <!-- <div class="label_item">亲子溜娃</div> -->
                    </div>
                  </div>
                  <template slot-scope="data" slot="right_time">
                    <div class="line_bottom">
                      <span v-if="item.mileage">全程{{item.mileage?item.mileage:0}}公里</span>
                      <span v-if="item.mileage && isShowDistance" class="middle">|</span>
                      <span v-if="isShowDistance">距你{{data.item.id}}米</span>
                    </div>
                  </template>
                </left-img>
                <template slot="right">
                  <div class="cell_right" @click="deleteItem(item)">
                    <div class="cell_right_content">
                      <div>取消</div>
                      <div>收藏</div>
                    </div>
                  </div>
                </template>
              </van-swipe-cell>

            </div>
          </div>
          <!-- 绿道线路 end -->

          <!-- 景点名片 -->
          <div class="strategy_container" v-if="activeIndex == 'spot_card'">
            <div class="item_container" v-for="(item,index) in scenicSpotListData" :key="index" @click="toDetail(item)">
              <van-swipe-cell class="vanSwipeCell">
                <div class="item_container_strategy">
                  <van-image :width="75" :height="100" class="item_left_img" :src="item.imageUrl" lazy-load />
                  <slot name="right_container">
                    <div class="item_right">
                      <div class="right_title">{{item.title}}</div>
                      <div class="right_label">
                        <div class="label_item" v-for="(item,index) in item.labels" :key="index">{{item}}</div>
                        <!-- <div class="label_item" v-for="">亲子溜娃</div> -->
                      </div>
                      <div class="right_time" v-if="item.scenicName">{{item.scenicName}}</div>
                      <div class="right_like" v-if="isShowDistance">距你{{calcDistance(item.latitude,item.longitude)}}km</div>
                    </div>
                  </slot>
                  <slot name="item_right"></slot>
                </div>
                <template slot="right">
                  <div class="cell_right" @click="deleteItem(item)">
                    <div class="cell_right_content">
                      <div>取消</div>
                      <div>收藏</div>
                    </div>
                  </div>
                </template>
              </van-swipe-cell>
            </div>
          </div>

          <!-- 景区线路 -->
          <div class="line_container" v-if="activeIndex == 'scenic_route'">
            <div class="line_item" v-for="(item,index) in scenicListData" :key="index" @click="toDetail(item)">
              <van-swipe-cell>
                <left-img :imageWidth="99" :imageHeight="66" :src="item.imageUrl" :item="item">
                  <div slot="right_like"></div>
                  <div slot="right_label">
                    <div class="right_label">
                      <div class="label_item" v-for="(item,index) in item.labels" :key="index">{{item}}</div>
                      <!-- <div class="label_item">亲子溜娃</div> -->
                    </div>
                  </div>
                  <template slot-scope="data" slot="right_time">
                    <div class="line_bottom">
                      <span v-if="item.mileage">全程{{item.mileage?item.mileage:0}}公里</span>
                      <span class="middle" v-if="item.mileage && isShowDistance">|</span>
                      <span v-if="isShowDistance">距你{{data.item.id}}米</span>
                    </div>
                  </template>
                </left-img>
                <template slot="right">
                  <div class="cell_right" @click="deleteItem(item)">
                    <div class="cell_right_content">
                      <div>取消</div>
                      <div>收藏</div>
                    </div>
                  </div>
                </template>
              </van-swipe-cell>
            </div>
          </div>
          <!-- 景区线路 end -->
        </div>
        <page-null :tipText="'还没有收藏任何内容，多去逛逛吧!'" :btnText="'去逛逛'" v-else></page-null>
      </div>
      <page-error v-else></page-error>

    </div>

  </div>
</template>
<script>
import Vue from 'vue';
import LeftImg from '@/components/LeftImgRightText';
import Loading from '@/components/loading';
import PageNull from '@/components/PageNull';
import PageError from '../../components/PageError';
import { timestampToTimeForActivity, getDistance } from '../../common/common'
import { Lazyload } from "vant";
Vue.use(Lazyload)
export default {
  data() {
    return {
      // 顶部区域listData
      topicList: [],
      //默认下顶部index的值
      activeIndex: '',
      // 景区线路 数据源
      scenicListData: [],
      // 绿道线路 数据源
      greenListData: [],
      // 攻略列表 数据源
      strategyListData: [],
      // 景点名片列表
      scenicSpotListData: [],
      // 活动列表 数据源
      activityListData: [],
      lat: '',
      lng: '',
      isLoading: true,
      isEmptyData: false,
      isPageError: false,
      isShowDistance: false
    };
  },
  components: {
    LeftImg,
    Loading,
    PageNull,
    PageError
  },
  mounted() {
    this.isShowDistance = Boolean(sessionStorage.getItem('isShowDistance'));
    this.latitude = sessionStorage.getItem('dislLat') || '';
    this.longitude = sessionStorage.getItem('dislLng') || '';
    console.log(this.latitude, 'this.latitude');
    console.log(this.longitude, 'this.longitude');
    this.getCollectData();

  },
  methods: {




    /**
     * 计算状态
     */
    computeStatus(item, type) {
      if (item.isResident == 1) {
        return "全年";
      }
      let dayTime = new Date().getTime();  // 当前时间
      let endTime = '';
      let startTime = '';
      let msg = '';
      if (type == '赛事') {
        endTime = new Date(item.end_time).getTime();  // 结束时间
        startTime = new Date(item.game_time).getTime(); // 开始时间
        if (dayTime < startTime) {
          msg = "离开始状态";
        } else if (startTime < dayTime && dayTime < endTime) {
          msg = "离结束状态";
        } else {
          msg = "已结束";
        }
      } else { // 活动
        endTime = new Date(item.activityEndTime).getTime();  // 结束时间
        startTime = new Date(item.activityStartTime).getTime(); // 开始时间
        if (dayTime < startTime) {
          msg = "离开始状态";
        } else if (startTime < dayTime && dayTime < endTime) {
          msg = "离结束状态";
        } else {
          msg = "已结束";
        }
      }
      return msg;
    },

    topicClick(index) {
      this.activeIndex = index;
    },
    /**
     * 跳转详情 
     */
    toDetail(item) {
      console.log(item, 'itmeitemitem');
      // if (item.isNormal === 0) {
      //   this.$toast(`${item.srcName}已删除或者已下线`);
      //   return;
      // }
      if (item.srcType == 'strategy') { // 攻略 srcId
        this.$router.push({
          path: '/strategyDetails',
          query: {
            id: item.srcId,
          },
        });
      } else if (item.srcType == 'scenic_route' || item.srcType == 'green_route') {  // 线路
        this.$router.push({
          path: '/lineDetails',
          query: {
            id: item.srcId,
          },
        });
      } else if (item.srcType == 'activity') {   // 活动
        this.$router.push({
          name: 'activityDetails',
          query: {
            id: item.srcId,
          },
        });
      } else if (item.srcType == 'match') {   // 赛事
        window.location.href = item.url;
      } else if (item.srcType == 'green_card') {   // 绿道名片
        this.$router.push({
          path: '/greenCard',
          query: {
            id: item.srcId
          },
        });
      } else if (item.srcType == 'scenic_card') {  //  景区名片
        this.$router.push({
          name: 'scenicParkDetail',
          query: {
            id: item.srcId
          },
        });
      } else if (item.srcType == 'spot_card') {   //  景点名片
        this.$router.push({
          name: 'scenicSpot',
          query: {
            id: item.srcId
          },
        });
      }
    },
    /**
     * 取消收藏
     */
    deleteItem(item) {
      let params = new FormData();
      params.append('srcType', item.srcType);
      params.append('srcId', item.srcId);
      this.$request.post(`/appserver/v1/collect/cancel`, (params)).then((data) => {
        if (data.data.ret === 0) {
          this.getCollectData();
          this.$toast(data.data.msg);
        } else {
          this.$toast(data.data.msg);
        }
      });
    },
    /**
    * 获取我的收藏列表
    */
    getCollectData() {
      this.isLoading = true;
      this.$request.post(`/appserver/v1/collect/list`).then((res) => {
        if (res.data.ret == 0) {
          let resData = res.data.data;
          // 数据为空
          if ((!resData || resData.length == 0)) {
            this.isEmptyData = true;
            this.isLoading = false;
            return;
          }
          console.log(resData, 'resDataresDataresData');
          let tabArr = [];

          for (let i in resData) {
            if (resData[i].key == 'food' || resData[i].key == 'hotel') {
              console.log('过滤')
            } else {
              tabArr.push({
                name: resData[i].name,
                key: resData[i].key
              });
            }
            if (resData[i].key == 'scenic_route') {// 景区线路list
              this.scenicListData = resData[i].list;
            } else if (resData[i].key == 'green_route') { // 绿道 list
              this.greenListData = resData[i].list;
            } else if (resData[i].key == 'strategy') { // 攻略 list
              this.strategyListData = resData[i].list;
            } else if (resData[i].key == 'activity') {  // 活动list
              this.activityListData = resData[i].list;
            } else if (resData[i].key == 'spot_card') {  // 景点 list
              this.scenicSpotListData = resData[i].list;
            }
          }
          if (tabArr[0].key) {
            this.activeIndex = tabArr[0].key;
          }
          this.topicList = tabArr;
          this.isLoading = false;

          // conole.log(tabArr, 'tabArr');
        } else {
          this.isLoading = false;
          this.isPageError = true;
        }
      }).catch((e) => {
        console.log(e);
        this.isLoading = false;
        this.isPageError = true;
      });
    },

    /**
     * 列表需要的日期转换
     */
    changeTime(startTime, endTime) {
      if (endTime) {
        let start = timestampToTimeForActivity(startTime);
        let end = timestampToTimeForActivity(endTime);
        return start + '-' + end;
      } else {
        return timestampToTimeForActivity(new Date(startTime).getTime());
      }

    },
    /**
     * 计算天数
     */
    computedDays(startTime, endTime) {
      let utc = endTime - startTime;
      return Math.ceil(utc / (24 * 60 * 60 * 1000)); // 天
    },

    /**
     * 计算公里数
     */
    calcDistance(lat, lng) {
      let latitude = Number(lat);
      let longitude = Number(lng);
      return getDistance(latitude, longitude, this.latitude, this.longitude).distance.toFixed(1);
    }

  },
};
</script>
<style lang="scss" scoped>
.my_collect {
  .topic_box {
    overflow-x: auto;
    white-space: nowrap;
    font-size: 14px;
    color: #787878;
    // display: flex;
    // justify-content: center;
    div {
      display: inline-block;
      height: 30px;
      line-height: 30px;
      margin: 0 20px;
      padding-top: 5px;
    }
    .active {
      color: #2eba73;
      border-bottom: 4px solid #2eba73;
    }
  }

  //   活动赛事
  .activity_container {
    padding-left: 20px;
    padding-top: 20px;
    .list {
      margin-top: 20px;
      .item_right_container {
        // width: 100%;
        width: calc(100% - 88px - 75px);
        display: flex;
        justify-content: space-between;
        .item_left {
          margin-left: 10px;

          .list_title {
            font-size: 16px;
            color: #262626;
            font-weight: bold;
          }
          .list_timeLine {
            display: flex;
            color: #787878;
            font-size: 12px;
            display: flex;
            // justify-content: center;
            align-items: center;
            margin-top: 6px;
            .timeLine_middle {
              margin: 0 3px;
            }
          }
          .item_location {
            display: flex;
            font-size: 12px;
            color: #787878;
            margin-top: 5px;
            .timeLine_middle {
              margin: 0 3px;
            }
          }
          .item_bottom {
            margin-top: 6px;
            display: flex;
            font-size: 12px;
            color: #787878;
          }
          .item_charge {
            margin-left: 3px;
            color: #2eba73;
          }
        }
      }
      .item_right {
        margin-left: 14px;
        width: 88px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-left: 1px solid rgba(0, 0, 0, 0.1);
        padding: 0;
        .right_text {
          font-size: 11px;
          color: rgba(0, 0, 0, 0.5);
        }
        .right_text_before {
          .before_day {
            font-size: 34px;
            color: #000000;
            span {
              font-size: 14px;
              margin-left: 1px;
            }
          }
          .before_desc {
            color: #787878;
            font-size: 11px;
          }
        }
        .right_green {
          color: #2eba73 !important;
          .before_day {
            font-size: 34px;
            color: #2eba73!important;
            span {
              font-size: 14px;
              margin-left: 1px;
            }
          }
          .before_desc {
            color: #2eba73!important;
            font-size: 11px;
          }
        }
      }
    }
    .list_topInfo {
      display: flex;
      background: rgba(143, 117, 255, 0.3);
      border-radius: 3px;
      padding: 5px 10px;
      color: #4f2ec4;
      justify-content: space-between;
      align-items: center;
      .topInfo_title {
        font-size: 14px;
        font-weight: bold;
      }
      .topInfo_right {
        font-size: 12px;
        display: flex;
        .topInfo_middle {
          margin: 0 3px;
        }
      }
    }
    .list {
      .item_container {
        display: flex;
        // margin-bottom: 25px;
        .item_right {
          //   width: calc(100% - 75px);
          //   padding-left: 14px;
          box-sizing: border-box;
          .right_title {
            font-size: 16px;
            color: black;
            font-weight: bold;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .right_time,
          .right_like {
            color: rgba(0, 0, 0, 0.5);
            font-size: 12px;
          }
          .right_like {
            margin-bottom: 0;
          }
          .right_label {
            display: flex;
            align-items: center;
            margin-bottom: 0px;
            height: 20px;
            overflow: hidden;
            flex-wrap: wrap;
            div {
              font-size: 11px;
              color: #6e5adb;
              background: rgba(97, 69, 247, 0.15);
              margin-right: 5px;
              padding: 2px 4px;
              border-radius: 3px;
            }
          }
          div {
            margin-bottom: 7px;
          }
        }
      }
      margin-top: 20px;
      .item_right_container {
        // width: 100%;

        display: flex;
        justify-content: space-between;
        .item_left {
          margin-left: 18px;
          .list_title {
            font-size: 16px;
            color: #262626;
            font-weight: bold;
          }
          .list_timeLine {
            display: flex;
            color: #787878;
            font-size: 12px;
            display: flex;
            // justify-content: center;
            align-items: center;
            margin-top: 6px;
            .timeLine_middle {
              margin: 0 3px;
            }
          }
          .item_location {
            display: flex;
            font-size: 12px;
            color: #787878;
            margin-top: 5px;
            .timeLine_middle {
              margin: 0 3px;
            }
          }
          .item_bottom {
            margin-top: 6px;
            display: flex;
            font-size: 12px;
            color: #787878;
          }
          .item_charge {
            margin-left: 3px;
            color: #2eba73;
          }
        }
      }
      .item_right {
        margin-left: 14px;
        width: 88px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-left: 1px solid rgba(0, 0, 0, 0.1);
        .right_text {
          font-size: 11px;
          color: rgba(0, 0, 0, 0.5);
        }
        .right_text_before {
          .before_day {
            font-size: 34px;
            color: #000000;
            span {
              font-size: 14px;
              margin-left: 1px;
            }
          }
          .before_desc {
            color: rgba(161, 158, 158, 0.5);
            font-size: 11px;
          }
        }
      }
    }
  }
  // 活动赛事 end

  //   攻略
  .strategy_container {
    // padding-left: 20px;
    padding-top: 20px;
    // padding-right: 20px;
    margin-top: 10px;
    .item_container {
      display: flex;
      // margin-bottom: 25px;
      // padding-right: 20px;
      // padding-left: 20px;
      .item_container_strategy {
        display: flex;
        padding-left: 20px;
        margin-bottom: 18px;
      }
      .vanSwipeCell {
        width: 100%;
      }
      .item_right {
        width: calc(100% - 75px);
        padding-left: 14px;
        box-sizing: border-box;
        .right_title {
          font-size: 16px;
          color: black;
          font-weight: bold;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .right_time,
        .right_like {
          color: rgba(0, 0, 0, 0.5);
          font-size: 12px;
        }
        .right_like {
          margin-bottom: 0;
        }
        .right_label {
          display: flex;
          align-items: center;
          margin-bottom: 0px;
          height: 20px;
          overflow: hidden;
          flex-wrap: wrap;
          div {
            font-size: 11px;
            color: #6e5adb;
            background: rgba(97, 69, 247, 0.15);
            margin-right: 5px;
            padding: 0px 4px;
            border-radius: 3px;
          }
        }
        div {
          margin-bottom: 7px;
        }
      }
    }
  }
  // 攻略 end

  //   游记
  // .traveks_container {
  //   .travels_list {
  //     .travels_item {
  //       margin-top: 20px;
  //       display: flex;
  //       padding-left: 20px;
  //       width: 100%;
  //       box-sizing: border-box;
  //       padding-right: 10px;
  //       color: rgba(0, 0, 0, 0.5);
  //       font-size: 11px;
  //       .right_container {
  //         padding-left: 20px;
  //         box-sizing: border-box;
  //         .travels_title {
  //           font-size: 16px;
  //           color: black;
  //           font-weight: bold;
  //         }
  //         .travels_userInfo {
  //           display: flex;
  //           margin-top: 6px;
  //           .nickName {
  //             margin-left: 6px;
  //           }
  //         }
  //         .traveks_bottom {
  //           margin-top: 6px;
  //           .bottom_left {
  //             margin-right: 6px;
  //           }
  //         }
  //       }
  //     }
  //     .travels_right {
  //       width: 80px;
  //       height: 100%;
  //       background: #f56262;
  //       font-size: 14px;
  //       color: white;
  //       display: flex;
  //       justify-content: center;
  //       align-items: center;
  //       flex-direction: column;
  //     }
  //   }
  // }
  // 游记 end
  //   线路
  .line_container {
    /deep/.item_container {
      margin-bottom: 0;
    }
    .line_item {
      padding-left: 20px;
      padding-right: 14px;
      box-sizing: border-box;
      margin-top: 20px;
      .line_bottom {
        font-size: 11px;
        color: rgba(0, 0, 0, 0.5);
        .middle {
          margin: 0 5px;
        }
      }
    }
    .right_label {
      height: 20px;
      overflow: hidden;
      flex-wrap: wrap;
    }
  }

  //   线路 end

  .cell_right {
    width: 80px;
    height: 100%;
    background: rgba(255, 114, 95, 1);
    font-size: 14px;
    color: rgba(255, 255, 255, 1);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    border-radius: 0px 2px 2px 0px;
    .cell_right_content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
  }
}
</style>
